import React from 'react';

import {
  Container,
  LoadingSpinner,
  LoadingSpinnerPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/components/loading-spinner.scss';
import '@consumer-bootstrap/index.scss';

export type CnuLoadingSpinnerT = React.FC<LoadingSpinnerPropsT & { className?: string; }>;

const defaultClasses = [
  'align-items-center',
  'd-flex',
  'flex-column',
  'justify-content-center',
  'm-0',
  'p-0',
].join(' ');

export const CnuLoadingSpinner: CnuLoadingSpinnerT = ({ className, ...props }) => {
  return (
    <Container className={`cnu-loading-spinner ${className || ''} ${defaultClasses}`}>
      <div className="">
        <LoadingSpinner {...props} />
      </div>
    </Container>
  );
};
